export default "__VITE_ASSET__b33a16e7__"